import { render, staticRenderFns } from "./ItemBox.vue?vue&type=template&id=2e448194&scoped=true"
import script from "./ItemBox.vue?vue&type=script&lang=js"
export * from "./ItemBox.vue?vue&type=script&lang=js"
import style0 from "./ItemBox.vue?vue&type=style&index=0&id=2e448194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e448194",
  null
  
)

export default component.exports